var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"border":"","columns":_vm.alarmData.title,"data":_vm.alarmData.data}}),_c('Page',{staticStyle:{"float":"right","margin-top":"10px"},attrs:{"total":_vm.alarmData.total,"page-size":_vm.alarmData.pageSize},on:{"on-change":_vm.getRecord2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }